var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"mode":"in-out"},on:{"enter":_vm.enter,"leave":_vm.leave,"afterLeave":_vm.destroy}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:[
            'pp-message',
            `pp-message--${_vm.position}`,
            _vm.customClass || '',
        ],style:(_vm.messageStyle)},[(_vm.type !== 'info')?_c('i',{class:[
                _vm.iconClass,
                'pp-message__icon',
            ]}):_vm._e(),_c('span',{staticClass:"pp-message__content"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }